import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ConstantsService {
  public readonly SafeAndWell_User_AD_GroupId =
    "217c0a43-8e6c-4246-84a9-2aa7e8164d23";
  public readonly SafeAndWell_Admin__AD_GroupId =
    "01dbb278-de67-4093-979c-b9c142f90610";
    public readonly SafeAndWell_Cat__AD_GroupId =
    "bda7cfeb-882a-4a76-9701-a9b415d733db";
}
